import React, { useEffect, useState } from 'react'
import { IComboBoxOption } from '@fluentui/react';
import { IUbicacionCommand } from '../../../../interfaces/ubicacion/IUbicacion';
import { codigosRespuesta, IResponseApiFluent } from '../../../../interfaces/base/IResponse';
import { LugarMovilizacionService } from '../../../../services/movilizacion/LugarMovilizacionService';
import { IOpenPanel } from '../../../../interfaces/base/IPanel';

const UseUbicacionCrear = (props: IOpenPanel) => {

    const initial: IUbicacionCommand = {
        nombre: "",
        codigo: "",
        requiereTransporte: false,
        requiereVueloComercial: false
    }

    const [command, setCommand] = useState<IUbicacionCommand>(initial);
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)

    const postInsertarUbicacion = () => {
        setLoading(true)
        LugarMovilizacionService.CrearLugarMovilizacion(command)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        cerrarPanel()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);

                    setTimeout(() => {
                        cerrarPanel()
                    }, 3000);
                } else {
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const cerrarPanel = () => {
        setMensaje("")
        setCommand(initial)
        setStatus(0)
        props.onDismiss()
    };

    const required: (keyof IUbicacionCommand)[] = [
        "codigo",
        "nombre"
    ];

    useEffect(() => {
        const check = required.every((field) => {
            const value = command[field];
            return value !== null && value !== undefined && value !== "";
        });
        setDisableForm(!check)
    }, [command])

    return { command, setCommand, postInsertarUbicacion, loading, disableForm, cerrarPanel, mensaje, status }
}

export { UseUbicacionCrear }